import { useState } from "react";
import { Phone, List, X } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/business";

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-zinc-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-between h-20 gap-6">
          <a href="/" className="flex items-center gap-3 shrink-0" data-testid="logo-link">
            <img src="/logo.png" alt="Milton401 Truck Parts" className="h-14 w-auto" />
          </a>

          <div className="hidden md:flex items-center gap-6">
            <a href={`tel:${BUSINESS.phoneTel}`} data-testid="header-phone-link" className="flex items-center gap-2 text-sm font-semibold hover:text-[#3DA935] transition-colors">
              <Phone size={18} weight="fill" className="text-[#3DA935]" /> {BUSINESS.phoneDisplay}
            </a>
            <a href="#quote" data-testid="header-quote-button" className="bg-[#3DA935] text-white text-xs font-bold uppercase tracking-widest px-5 py-3 hover:bg-black transition-colors">
              Request a Quote
            </a>
          </div>

          <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-button">
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden py-4 border-t border-zinc-200 space-y-3" data-testid="mobile-menu">
            <a href={`tel:${BUSINESS.phoneTel}`} className="flex items-center gap-2 text-sm font-semibold">
              <Phone size={18} weight="fill" className="text-[#3DA935]" /> {BUSINESS.phoneDisplay}
            </a>
            <a href="#quote" onClick={() => setOpen(false)} className="block bg-[#3DA935] text-white text-center text-xs font-bold uppercase tracking-widest px-5 py-3">
              Request a Quote
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
